import {SmileyIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {VALUES} from '../constants/values'
import styles from './ReactionViewerAnchor.module.css'

type RenderAnchorProps = React.HTMLAttributes<HTMLElement> & {ref?: React.Ref<HTMLElement>}
type ReactionViewerAnchorProps = {
  renderAnchorProps?: RenderAnchorProps
  reactionsAvailable?: boolean
  ref?: React.Ref<HTMLButtonElement>
}

export const ReactionViewerAnchor = ({ref, renderAnchorProps, reactionsAvailable}: ReactionViewerAnchorProps) => {
  const {ref: anchorRef, ...restAnchorProps} = renderAnchorProps ?? {}

  return (
    <IconButton
      size="small"
      icon={SmileyIcon}
      {...restAnchorProps}
      aria-label={reactionsAvailable ? VALUES.react : VALUES.reactionsUnavailable}
      inactive={!reactionsAvailable}
      aria-labelledby={undefined}
      className={styles.ReactionViewerAnchorButton}
      ref={mergeRefs([ref, anchorRef])}
    />
  )
}

/** Merges multiple refs into a single ref callback. */
function mergeRefs<T>(refs: Array<React.Ref<T> | undefined>): React.RefCallback<T> {
  return (value: T | null) => {
    for (const r of refs) {
      if (typeof r === 'function') {
        r(value)
      } else if (r != null) {
        ;(r as React.MutableRefObject<T | null>).current = value
      }
    }
  }
}

ReactionViewerAnchor.displayName = 'ReactionViewerAnchor'
